/* DateEditor.js */

"use strict";

const CommonEditor = require("./CommonEditor");

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const DateControl = uiCore.Control.Timestamp.DatePicker;

class DateEditor extends CommonEditor {
    constructor(options) {
        super(options);
        const date = new Date(options.item.expirationDate);
        const inputForDatePicker = {
            year: date.getFullYear(),
            month: date.getMonth(),
            date: date.getDate(),
        };

        this.input.setValue(inputForDatePicker);
    }

    _createInput() {
        const dateControl = new DateControl({
            darkTheme: true,
        });

        return dateControl;
    }

    /*****************************/
    /*  PUBLIC API IS INHERITED  */
    /*****************************/
}

module.exports = DateEditor;
